import { render, staticRenderFns } from "./updataPassword.vue?vue&type=template&id=5f82e291&scoped=true&"
import script from "./updataPassword.vue?vue&type=script&lang=js&"
export * from "./updataPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82e291",
  null
  
)

export default component.exports